import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=531ca78a&"
import script from "./customerDetail.vue?vue&type=script&lang=js&"
export * from "./customerDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=531ca78a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports